import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./App/Components/reveal/reveal.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./static/css/homepage.css";

import * as serviceWorker from "./serviceWorker";
import { AppThemeProvider } from "./theme";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <App />
    </AppThemeProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
